import { InputType, SOFQuestion } from './SOF.types';

export const SOF_BOTTOM_SHEET_LAST_SHOW_TIME_STORAGE_KEY =
  'sourceOfFundsBottomSheetLastShowTime';

export const SOF_BOTTOM_SHEET_SHOW_INTERVAL = 1000 * 60 * 60 * 48; // 48 hours

export const SOF_STATE_PERSISTENCE_DELAY = 1000;

export const leadingZeroNumberRegex = /^0\d*$/;

export const onlyNumbersWithoutZeroRegex = /^[1-9]\d*(?:[.,]\d+)*$/;

const SOF_OPTIONS_KEYS = Array.from({ length: 10 }, (_, i) => `option.${i}`);

export const SOF_QUESTIONS: SOFQuestion[] = [
  {
    id: '1',
    title: 'question.1.title',
    type: 'checkbox',
    required: true,
    options: [
      ...SOF_OPTIONS_KEYS.map((key, index) => ({
        controlId: `1-${index + 1}`,
        text: key,
        inputType: InputType.AMOUNT,
      })),
      {
        controlId: '1-11',
        text: 'option.10',
        inputType: InputType.INCOME,
      },
    ],
  },
  {
    id: '2',
    title: 'question.2.title',
    type: 'checkbox',
    required: true,
    options: [
      {
        controlId: '2-1',
        text: 'question2.option.1',
        inputType: InputType.EMPLOYED,
      },
      {
        controlId: '2-2',
        text: 'question2.option.2',
        inputType: InputType.SELF_EMPLOYED,
      },
      {
        controlId: '2-3',
        text: 'question2.option.3',
      },
    ],
  },
  {
    id: '3',
    title: 'question.3.title',
    type: 'text',
    required: false,
    controlId: '3-1',
  },
];

export const SOF_QUESTIONS_CONFIG: Record<SOFQuestion['id'], SOFQuestion> =
  SOF_QUESTIONS.reduce(
    (accumulator, question) => ({
      ...accumulator,
      [question.id]: question,
    }),
    {},
  );

export const SOF_REGEX = /^.{3,150}$/;

export const TitleMap: Record<string, string> = {
  ['question.1.title']:
    'What are your sources of funding for activities with Bonanza? (Select all that apply)',
  ['question.2.title']: 'Occupation (Select all that apply)',
  ['question.3.title']:
    'Additional information you would like to share about your source of funds (Optional)',
};

export const OptionsMap: Record<string, string> = {
  ['option.0']: 'Employment income',
  ['option.1']: 'Profit from business',
  ['option.2']: 'Pension',
  ['option.3']: 'Government benefits',
  ['option.4']: 'Inheritance',
  ['option.5']: 'Winnings from other providers',
  ['option.6']: 'Settlement',
  ['option.7']: 'Sale of Property or Other Possessions',
  ['option.8']: 'Investments',
  ['option.9']: 'Savings',
  ['option.10']: 'Other',
  ['question2.option.1']: 'Employed',
  ['question2.option.2']: 'Self-Employed',
  ['question2.option.3']: 'Unemployed',
};
